/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} formatType date/time/datetime
 * @returns {string}
 */
export function formatTime(time, formatType) {
  const d = new Date(time);
  var hour = d.getHours();
  if (hour < 10) {
    hour = "0" + hour;
  }
  var minute = d.getMinutes();
  if (minute < 10) {
    minute = "0" + minute;
  }
  var second = d.getSeconds();
  if (second < 10) {
    second = "0" + second;
  }

  var formatResult = "";
  switch (formatType) {
    case "date":
      formatResult =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      break;
    case "time":
      formatResult = hour + ":" + minute + ":" + second;
      break;
      case "minute":
      formatResult = hour + ":" + minute;
      break;
    case "datetime":
      formatResult =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        "  " +
        hour +
        ":" +
        minute +
        ":" +
        second;
      break;
    case "week":
      var weekNum = d.getDay();
      switch (weekNum) {
        case 0:
          formatResult = "星期日";
          break;
        case 1:
          formatResult = "星期一";
          break;
        case 2:
          formatResult = "星期二";
          break;
        case 3:
          formatResult = "星期三";
          break;
        case 4:
          formatResult = "星期四";
          break;
        case 5:
          formatResult = "星期五";
          break;
        case 6:
          formatResult = "星期六";
          break;
      }

      break;
    default:
      formatResult =
        d.getFullYear() +
        "年" +
        (d.getMonth() + 1) +
        "月" +
        d.getDate() +
        "日  " +
        hour +
        ":" +
        minute +
        ":" +
        second;
      break;
  }
  return formatResult;
}

/**
 * 设置跟节点 fonst-size
 */
export function setRootHtmlFontSize() {
  const rootHtmlDOM = document.getElementsByTagName("html")[0];
  const w = rootHtmlDOM.offsetWidth;
  // 1920px为UI图的设计稿尺寸
  const fs = Math.round((w / 1920) * 10 * 10 * 10) / 10;
  rootHtmlDOM.style.fontSize = `${fs}px`;
  console.log(rootHtmlDOM.style.fontSize);
}

/**
 * 生成随机数
 * @param {INT} minNum  最小值
 * @param {INT} maxNum   最大值
 * @returns
 */
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
      break;
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      break;
    default:
      return 0;
      break;
  }
}

export function coverFontSize(fontSize) {}

function coverWindDirection(windDirection) {
  var windDirectionText = "东风";
  if (
    (windDirection >= 0 && windDirection < 22.5) ||
    (windDirection >= 337.5 && windDirection <= 360)
  ) {
    var windDirectionText = "北风";
  } else if (windDirection >= 22.5 && windDirection < 67.5) {
    var windDirectionText = "东北风";
  } else if (windDirection >= 67.5 && windDirection < 112.5) {
    var windDirectionText = "东风";
  } else if (windDirection >= 112.5 && windDirection < 157.5) {
    var windDirectionText = "东南风";
  } else if (windDirection >= 157.5 && windDirection < 202.5) {
    var windDirectionText = "南风";
  } else if (windDirection >= 202.5 && windDirection < 247.5) {
    var windDirectionText = "西南风";
  } else if (windDirection >= 247.5 && windDirection < 292.5) {
    var windDirectionText = "西风";
  } else if (windDirection >= 292.5 && windDirection < 337.5) {
    var windDirectionText = "西北风";
  }

  return windDirectionText;
}

export default {
  coverWindDirection
};



// WEBPACK FOOTER //
// ./src/js/index.js